module.exports = __webpack_public_path__ + "img/Mockup_2.3797f0b9.jpg";